module.exports = __webpack_public_path__ + "static/media/earthArrowLeft_active.5a9b4d71.svg";